/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsUserAddOns,
    IdentityMelcoModelsUserAddOnsFromJSON,
    IdentityMelcoModelsUserAddOnsFromJSONTyped,
    IdentityMelcoModelsUserAddOnsToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsUserAddOns
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsUserAddOns {
    /**
     * 
     * @type {Array<IdentityMelcoModelsUserAddOns>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserAddOns
     */
    list: Array<IdentityMelcoModelsUserAddOns>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserAddOns
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsUserAddOns
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsUserAddOns {
    return IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsUserAddOns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsUserAddOnsFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsUserAddOns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsUserAddOnsToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


